export function executeScriptsFromHTML(html) {
    const div = document.createElement("div");
    div.innerHTML = html;

    // Extract scripts
    const scripts = div.querySelectorAll("script");

    scripts.forEach(originalScript => {
        const newScript = document.createElement("script");

        if (originalScript.src) {
            // External script
            newScript.src = originalScript.src;
        } else {
            // Inline script
            let content = originalScript.innerHTML;
            newScript.text = content;
        }

        document.head.appendChild(newScript);
        document.head.removeChild(newScript);
    });

    return div.innerHTML;
}